import { ApiClientProps } from "hooks/useApi";

interface LocationLatestUpdateResponse {
  hasErrors: boolean;
  message: string;
  resource: {
    partner_id: number;
    location_id: string;
    username: string;
    pos_type: string;
    event_type: string;
    created_at: string;
  };
}

interface GetLocationDetailsProps {
  id?: string;
  partnerId?: string;
  apiClient: ApiClientProps;
}

async function getLocationLatestUpdate({
  id,
  partnerId,
  apiClient,
}: GetLocationDetailsProps): Promise<LocationLatestUpdateResponse | null> {

  if (!id || !partnerId) {
    throw new Error("ID or PartnerID missing for fetching location latest update");
  }

  try {
    const response = await apiClient.get({
      path: `/middleware-admin/partners/${partnerId}/locations/${id}/audit/latest`,
      noRetry: true,
    });

    return response;
  } catch (error) {
    throw new Error(
      "Network request error trying to fetch the location latest update"
    );
  }
}

export default getLocationLatestUpdate;
